import type { WithActiveBranchId } from '../shared';

export enum AiOperatorConfigEndpoints {
  Get = 'Get',
  Update = 'Update',
  GetDefaultProfile = 'GetDefaultProfile',
}

export interface AiOperatorConfigViewDto {
  OperatorProfile: string | null;
  MaxSentences: number;
  Tone: string | null;
  MandatoryCTA: string | null;
  MessageTemplatesJson: string | null;
  LlmProvider: string | null;
  LlmModel: string | null;
  GenericDialogV2Mode: string | null;
  EndDialogDays: number;
  EndDialogHours: number;
  EndDialogMinutes: number;
  EndDialogSeconds: number;
  GroupingMinutes: number;
  GroupingSeconds: number;
  BranchIds: number[] | null;
}

export type GetAiOperatorConfigRequest = WithActiveBranchId<{
  userId: number;
}>;

export type UpdateAiOperatorConfigRequest = WithActiveBranchId<{
  userId: number;
  data: AiOperatorConfigViewDto;
}>;

export type GetDefaultProfileRequest = WithActiveBranchId;

export type GetAiOperatorConfigResponse = AiOperatorConfigViewDto;
export type UpdateAiOperatorConfigResponse = AiOperatorConfigViewDto;
export type GetDefaultProfileResponse = string;
